import React, { FC } from 'react'
import { CheckWithElement, ListWithImg } from 'Pages/landings/newLandings/common/components'
import forCouriersWebp from './forCouriers.webp'
import forCouriersJpg from './forCouriers.jpg'
import { Title, Text } from './styled'

export const ForCouriersComponent: FC = () => (
	<ListWithImg imgWebp={forCouriersWebp} imgJpg={forCouriersJpg} isReverse>
		<Title>Для курьеров</Title>
		<CheckWithElement text={() => <Text>Для служб доставки</Text>} />
		<CheckWithElement text={() => <Text>Для такси</Text>} />
		<CheckWithElement text={() => <Text>Для продавцов-консультантов</Text>} />
	</ListWithImg>
)
